import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { globalDashboardContainer } from '../../di/container';

export function useClassVsGeneral() {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: ['global-dashboard', 'class-vs-general', institutionName],
    queryFn: () =>
      globalDashboardContainer.repository.getClassVSGeneral(institutionName!),
    enabled: isAuthenticated,
    retry: false,
  });
}
